import React from "react";
import Button from 'components/Button/Button';
import { graphqlCodeSandboxURL } from "app/helpers/graphqlHelpers";
import LanguageCode from "./LanguageCode";
var getCodeSnippetUrl = function (usecase, language) {
    switch (language) {
        case 'javascript':
            return "https://github.com/neo4j-graph-examples/".concat(usecase, "/tree/main/code/javascript/example.js");
        case 'java':
            return "https://github.com/neo4j-graph-examples/".concat(usecase, "/tree/main/code/java/Example.java");
        case 'python':
            return "https://github.com/neo4j-graph-examples/".concat(usecase, "/tree/main/code/python/example.py");
        case 'graphql':
            return "https://github.com/neo4j-graph-examples/".concat(usecase, "/tree/main/code/graphql/example.js");
        case 'graphqlschema':
            return "https://github.com/neo4j-graph-examples/".concat(usecase, "/tree/main/graphql/schema.graphql");
        case 'go':
            return "https://github.com/neo4j-graph-examples/".concat(usecase, "/tree/main/code/go/example.go");
        case 'csharp':
            return "https://github.com/neo4j-graph-examples/".concat(usecase, "/tree/main/code/csharp/Example.cs");
        default:
            break;
    }
    return null;
};
var getCodeInstructions = function (code, sandboxData) { return ({
    js: {
        steps: [
            {
                text: (React.createElement("p", null,
                    React.createElement("b", null, "Step 1"),
                    ": Install Neo4j Driver using npm. For more information, see the ",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "https://neo4j.com/docs/javascript-manual/current/", rel: "noreferrer" }, "Javascript Driver Docs"),
                    ".")),
                code: 'npm install --save neo4j-driver',
                codeEle: true,
                copyableText: 'npm install --save neo4j-driver',
            },
            {
                text: (React.createElement("span", null,
                    React.createElement("b", null, "Step 2"),
                    ": Copy the code to your project")),
                code: (React.createElement(LanguageCode, { language: "javascript", code: code.js })),
                codeEle: false,
            },
            {
                text: (React.createElement("span", null,
                    React.createElement("b", null,
                        "Checkout the code at github: ",
                        React.createElement("a", { href: getCodeSnippetUrl(sandboxData.usecase, "javascript") }, "here")))),
            }
        ],
    },
    py: {
        steps: [
            {
                text: (React.createElement("p", null,
                    React.createElement("b", null, "Step 1"),
                    ": Install Neo4j Driver using pip. For more information, see the ",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "https://neo4j.com/docs/python-manual/current/", rel: "noreferrer" }, "Python Driver Docs"),
                    ".")),
                code: 'pip install neo4j-driver',
                copyableText: 'pip install neo4j-driver',
                codeEle: true,
            },
            {
                text: (React.createElement("span", null,
                    React.createElement("b", null, "Step 2"),
                    ": Copy the code to your project")),
                code: (React.createElement(LanguageCode, { language: "python", code: code.py })),
                codeEle: false,
            }, {
                text: (React.createElement("span", null,
                    React.createElement("b", null,
                        "Checkout the code at github: ",
                        React.createElement("a", { href: getCodeSnippetUrl(sandboxData.usecase, "python") }, "here")))),
            }
        ],
    },
    java: {
        steps: [
            {
                codeEle: false,
                text: (React.createElement("p", null,
                    React.createElement("b", null, "Step 1"),
                    ": Install the ",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "https://central.sonatype.com/artifact/org.neo4j.driver/neo4j-java-driver/", rel: "noreferrer" }, "Neo4j Java Driver"),
                    ". For more information, see the ",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "https://neo4j.com/docs/java-manual/current/", rel: "noreferrer" }, "Java Driver Docs"),
                    ".")),
                code: null,
            },
            {
                codeEle: false,
                text: (React.createElement("span", null,
                    React.createElement("b", null, "Step 2"),
                    ": Copy the code to your project")),
                code: (React.createElement(LanguageCode, { language: "text/x-java", code: code.java })),
            },
            {
                text: (React.createElement("span", null,
                    React.createElement("b", null,
                        "Checkout the code at github: ",
                        React.createElement("a", { href: getCodeSnippetUrl(sandboxData.usecase, "java") }, "here")))),
            }
        ],
    },
    go: {
        steps: [
            {
                text: (React.createElement("p", null,
                    React.createElement("b", null, "Step 1"),
                    ": Copy the code into a file called example.go")),
                code: (React.createElement(LanguageCode, { language: "text/x-go", code: code.go })),
                codeEle: false,
            },
            {
                text: (React.createElement("span", null,
                    React.createElement("b", null,
                        "Checkout the code at github: ",
                        React.createElement("a", { href: getCodeSnippetUrl(sandboxData.usecase, "go") }, "here")))),
            },
            {
                text: (React.createElement("p", null,
                    React.createElement("b", null, "Step 2"),
                    ": Initiate the go module")),
                code: 'go mod init main',
                codeEle: true,
                copyableText: 'go mod init main',
            },
            {
                text: (React.createElement("p", null,
                    React.createElement("b", null, "Step 3"),
                    ": Run the example.go file")),
                code: 'go run example.go',
                codeEle: true,
                copyableText: 'go run example.go',
            },
            {
                text: (React.createElement("p", null,
                    React.createElement("b", null, "Step 4"),
                    ": For more information, see the ",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "https://neo4j.com/docs/go-manual/current/", rel: "noreferrer" }, "Go Driver Docs"),
                    ".")),
                codeEle: false,
            }
        ]
    },
    csharp: {
        steps: [
            {
                text: (React.createElement("p", null,
                    React.createElement("b", null, "Step 1"),
                    ": Install dotnet core on your system"))
            },
            {
                text: (React.createElement("p", null,
                    React.createElement("b", null, "Step 2"),
                    ": Create a new console project")),
                code: 'dotnet new console -o .',
                codeEle: true,
                copyableText: 'dotnet new console -o .',
            },
            {
                text: (React.createElement("p", null,
                    React.createElement("b", null, "Step 3"),
                    ": Add the Neo4j driver")),
                code: 'dotnet add package Neo4j.Driver',
                codeEle: true,
                copyableText: 'dotnet add package Neo4j.Driver',
            },
            {
                text: (React.createElement("p", null,
                    React.createElement("b", null, "Step 4"),
                    ": Paste the following code into Program.cs")),
                code: (React.createElement(LanguageCode, { language: "text/x-csharp", code: code.csharp })),
            }, {
                text: (React.createElement("span", null,
                    React.createElement("b", null,
                        "Checkout the code at github: ",
                        React.createElement("a", { href: getCodeSnippetUrl(sandboxData.usecase, "csharp") }, "here")))),
            },
            {
                text: (React.createElement("p", null,
                    React.createElement("b", null, "Step 5"),
                    ": Run the project.")),
                code: 'dotnet run',
                codeEle: true,
                copyableText: 'dotnet run',
            },
            {
                text: (React.createElement("p", null,
                    React.createElement("b", null, "Step 6"),
                    ": For more information, see the ",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "https://neo4j.com/docs/donet-manual/current/", rel: "noreferrer" }, ".NET Driver Docs"),
                    ".")),
                codeEle: false,
            }
        ]
    },
    graphql: {
        steps: [
            {
                text: (React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "mb4" },
                        "The",
                        ' ',
                        React.createElement("a", { href: "https://www.npmjs.com/package/@neo4j/graphql", target: "_blank", rel: "noreferrer" }, "@neo4j/graphql"),
                        ' ',
                        "library enables developers to build Node.js GraphQL APIs backed by Neo4j without writing any boilerplate data fetching logic. You can get started either by deploying to CodeSandbox or run locally."),
                    React.createElement(Button, { target: "_blank", className: "btn btn-info", href: graphqlCodeSandboxURL("bolt://".concat(sandboxData.ip, ":").concat(sandboxData.boltPort), 'neo4j', sandboxData.password, code.graphqlschema) }, "Deploy to CodeSandbox"),
                    React.createElement("p", { className: "mt3 mb3" }, "OR"),
                    React.createElement("p", { className: "font-bold font-size-normal text-underline" }, "Run Locally"))),
            },
            {
                text: (React.createElement("p", null,
                    React.createElement("b", null, "Step 1"),
                    ": Install the Neo4j GraphQL Library, @neo4j/graphql using npm. Read more about",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "https://neo4j.com/docs/graphql-manual/current/", rel: "noreferrer" }, "the Neo4j GraphQL Library in the documentation."))),
                code: 'npm install @neo4j/graphql graphql neo4j-driver apollo-server',
                codeEle: true,
                copyableText: 'npm install @neo4j/graphql graphql neo4j-driver apollo-server',
            },
            {
                text: (React.createElement("span", null,
                    React.createElement("b", null, "Step 2"),
                    ": Copy the code to your project file index.js and run with the command ",
                    React.createElement("code", null, "node index.js"),
                    " This will start a local GraphQL server at http://localhost:4000, which you can then open in your web browser and query with GraphQL Playground.")),
                code: (React.createElement(LanguageCode, { language: "javascript", code: code.graphql })),
                codeEle: false,
            },
            {
                text: (React.createElement("span", null,
                    React.createElement("b", null,
                        "Checkout the code at github: ",
                        React.createElement("a", { href: getCodeSnippetUrl(sandboxData.usecase, "graphql") }, "here")))),
            }
        ],
    },
}); };
export default getCodeInstructions;
